import { render } from "./Inputer.vue?vue&type=template&id=197ef158&scoped=true"
import script from "./Inputer.vue?vue&type=script&lang=js"
export * from "./Inputer.vue?vue&type=script&lang=js"

import "./Inputer.vue?vue&type=style&index=0&id=197ef158&scoped=true&lang=css"
import "./Inputer.vue?vue&type=style&index=1&id=197ef158&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197ef158"]])

export default __exports__